import { axiosInstance } from '../shared/axios/axiosConfig';
import { USER_SERVICE_API_URL } from 'services/constants';

/**
 * Call the controller to get the user details of the logged in user
 */
const getUser = async () => {
  const json = await axiosInstance.get(`${USER_SERVICE_API_URL}/getUserDetails`);
  return json.data;
};

const userService = { getUser };
export default userService;
